/**
 * 分页数据
 */
export interface PageResult<T> {
  /**
   * 总记录数
   */
  totalCount?: number;
  /**
   * 是否有下一页数据
   */
  hasNextPage?: boolean;
  /**
   * 当前页数据列表项
   */
  dataList: T[];
}

/**
 * 分页处理类
 */
export default class Pagination {
  /**
   * 当前页码
   */
  pageIndex = 0;

  /**
   * 每页展示内容个数
   */
  pageSize = 8;

  /**
   * 总记录数
   */
  totalCount = 0;

  /**
   * 是否有下一页数据
   */
  hasNextPage = true;

  /**
   * 构造函数
   * @param pageSize 每页展示内容大小
   */
  constructor(pageSize?: number) {
    if (pageSize) {
      this.pageSize = pageSize;
    }
  }

  /**
   * 设置分页信息
   * @param result
   */
  update<T>(result: PageResult<T>) {
    const { totalCount, hasNextPage, dataList } = result;
    const { length } = dataList;
    // 更新记录总数
    this.totalCount = totalCount || 0;
    // 如果查询回来的数据项小于分页个数，说明已经查完数据了
    if (hasNextPage === false || (length < this.pageSize && !hasNextPage)) {
      this.hasNextPage = false;
    }
    // 如果有查询到数据，页码自动加1
    if (length > 0 || (hasNextPage && length === 0)) {
      this.pageIndex += 1;
    }
  }

  /**
   * 获取分野查询参数
   */
  getQueryParams() {
    const { pageIndex, pageSize } = this;
    return {
      offset: pageIndex * pageSize,
      limit: pageSize,
    };
  }
}

